import axios from "axios";

export const getChatBotResponse = async (URL: string, data: any) => {
  return await axios.post(URL, {
    messages: data,
  });
};

export const getFAQuestions = async (URL: string) => {
  try {
    const result = await axios.get(URL);
    if (result.data.success) {
      return result.data.response?.slive(0, 3);
    } else {
      return undefined;
    }
  } catch (error: unknown) {
    return undefined;
  }
};
